(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gs-hero-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gs-hero-slider')) {
    class GsHeroSlider extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-gs-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-gs-dot]'));
        this.index = 0;
        if (this.slides.length < 2) return;
        this.querySelector('[data-gs-prev]')?.addEventListener('click', () => this.go(this.index - 1, true));
        this.querySelector('[data-gs-next]')?.addEventListener('click', () => this.go(this.index + 1, true));
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(Number(dot.dataset.gsDot), true)));
        this.addEventListener('pointerenter', () => (this.paused = true));
        this.addEventListener('pointerleave', () => (this.paused = false));
        this.addEventListener('focusin', () => (this.paused = true));
        this.addEventListener('focusout', () => (this.paused = false));
        this.addEventListener('shopify:block:select', (e) => {
          const i = this.slides.indexOf(e.target.closest('[data-gs-slide]'));
          if (i >= 0) this.go(i, true);
        });
        let startX = null;
        this.addEventListener('touchstart', (e) => (startX = e.touches[0].clientX), { passive: true });
        this.addEventListener('touchend', (e) => {
          if (startX === null) return;
          const dx = e.changedTouches[0].clientX - startX;
          if (Math.abs(dx) > 40) this.go(this.index + (dx < 0 ? 1 : -1), true);
          startX = null;
        });
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (this.dataset.autoplay === 'true' && !reduced && !window.Shopify?.designMode) {
          const ms = Math.max(3000, Number(this.dataset.interval) || 6000);
          this.timer = window.setInterval(() => {
            if (!this.paused && !document.hidden) this.go(this.index + 1);
          }, ms);
        }
      }
      disconnectedCallback() {
        window.clearInterval(this.timer);
      }
      go(i, user = false) {
        const n = this.slides.length;
        this.index = ((i % n) + n) % n;
        this.slides.forEach((slide, k) => {
          const active = k === this.index;
          if (active) slide.removeAttribute('aria-hidden');
          else slide.setAttribute('aria-hidden', 'true');
          slide.querySelectorAll('a').forEach((a) => (active ? a.removeAttribute('tabindex') : a.setAttribute('tabindex', '-1')));
        });
        this.dots.forEach((dot, k) => (k === this.index ? dot.setAttribute('aria-current', 'true') : dot.removeAttribute('aria-current')));
        if (user) this.paused = true;
      }
    }
    customElements.define('gs-hero-slider', GsHeroSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gs-home-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gs-home-slider')) {
    class GsHomeSlider extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-gs-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-gs-dot]'));
        this.index = 0;
        if (this.slides.length < 2) return;
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(Number(dot.dataset.gsDot), true)));
        this.addEventListener('pointerenter', () => (this.paused = true));
        this.addEventListener('pointerleave', () => (this.paused = false));
        this.addEventListener('focusin', () => (this.paused = true));
        this.addEventListener('focusout', () => (this.paused = false));
        this.addEventListener('shopify:block:select', (e) => {
          const i = this.slides.indexOf(e.target.closest('[data-gs-slide]'));
          if (i >= 0) this.go(i, true);
        });
        let startX = null;
        this.addEventListener('touchstart', (e) => (startX = e.touches[0].clientX), { passive: true });
        this.addEventListener('touchend', (e) => {
          if (startX === null) return;
          const dx = e.changedTouches[0].clientX - startX;
          if (Math.abs(dx) > 40) this.go(this.index + (dx < 0 ? 1 : -1), true);
          startX = null;
        });
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (this.dataset.autoplay === 'true' && !reduced && !window.Shopify?.designMode) {
          const ms = Math.max(4000, Number(this.dataset.interval) || 7000);
          this.timer = window.setInterval(() => {
            if (!this.paused && !document.hidden) this.go(this.index + 1);
          }, ms);
        }
      }
      disconnectedCallback() {
        window.clearInterval(this.timer);
      }
      go(i, user = false) {
        const n = this.slides.length;
        this.index = ((i % n) + n) % n;
        this.slides.forEach((slide, k) => {
          const active = k === this.index;
          if (active) slide.removeAttribute('aria-hidden');
          else slide.setAttribute('aria-hidden', 'true');
          slide.querySelectorAll('a').forEach((a) => (active ? a.removeAttribute('tabindex') : a.setAttribute('tabindex', '-1')));
        });
        this.dots.forEach((dot, k) => (k === this.index ? dot.setAttribute('aria-current', 'true') : dot.removeAttribute('aria-current')));
        if (user) this.paused = true;
      }
    }
    customElements.define('gs-home-slider', GsHomeSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
